import { render, staticRenderFns } from "./ExamResultGrade10.vue?vue&type=template&id=ddca0664&scoped=true&"
import script from "./ExamResultGrade10.vue?vue&type=script&lang=js&"
export * from "./ExamResultGrade10.vue?vue&type=script&lang=js&"
import style0 from "./ExamResultGrade10.vue?vue&type=style&index=0&id=ddca0664&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddca0664",
  null
  
)

export default component.exports